var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"not-found-page-box"},[_c('p',{staticClass:"not-found-page-box__text"},[_vm._v("Хоба!")]),_c('img',{staticClass:"not-found-page-box__img",attrs:{"src":require("../assets/img/sad-cat.png"),"width":"100px","alt":"хоба-текст"}}),_c('p',{staticClass:"not-found-page-box__text"},[_vm._v("Страница не найдена")])])
}]

export { render, staticRenderFns }